import { motion } from "framer-motion";
import { Clock, Gauge, ArrowUpRight } from "lucide-react";
import { useLang, usePick } from "@/i18n/LanguageContext";

export default function ExcursionCard({ excursion, onBook }) {
  const { t } = useLang();
  const pick = usePick();
  return (
    <motion.article
      data-testid={`excursion-card-${excursion.id}`}
      whileHover={{ y: -6 }}
      transition={{ duration: 0.25 }}
      className="group bg-white rounded-3xl overflow-hidden shadow-[0_2px_24px_rgba(22,27,34,0.07)] border border-terracotta/10 flex flex-col"
    >
      <div className="relative h-56 overflow-hidden">
        <img
          src={excursion.image}
          alt={excursion.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute top-4 left-4 bg-sand/90 backdrop-blur px-3 py-1 rounded-full text-[11px] font-mono uppercase tracking-[0.15em] text-teal">
          {excursion.category}
        </span>
        <span className="absolute bottom-4 right-4 bg-terracotta text-sand px-3 py-1.5 rounded-full text-sm font-semibold shadow-lg">
          ${excursion.price} {t("excursions.perPerson")}
        </span>
      </div>
      <div className="p-6 flex flex-col gap-3 grow">
        <h3 className="font-serif text-2xl leading-snug text-ink">{pick(excursion, "title")}</h3>
        <p className="text-sm text-ink/60 leading-relaxed line-clamp-2">{pick(excursion, "description")}</p>
        <div className="flex items-center gap-4 text-xs text-ink/50 mt-auto pt-1">
          <span className="flex items-center gap-1.5">
            <Clock size={14} /> {excursion.duration}
          </span>
          <span className="flex items-center gap-1.5">
            <Gauge size={14} /> {excursion.difficulty}
          </span>
        </div>
        <button
          data-testid={`book-excursion-btn-${excursion.id}`}
          onClick={() => onBook(excursion)}
          className="mt-2 w-full rounded-full bg-night text-sand py-3 text-sm font-semibold hover:bg-terracotta transition-colors flex items-center justify-center gap-2"
        >
          {t("excursions.book")} <ArrowUpRight size={16} />
        </button>
      </div>
    </motion.article>
  );
}
